import { Box, IconButton, Typography } from '@material-ui/core';
import { getMonthName } from '../constants/datatypes';
import MyIcon from './MyIcon';

function MonthNavigator({ month, setMonth, year, setYear, isRTL }: any) {
  const mo = getMonthName({ num: month, isRTL });
  const goLeft = () => {
    if (month === 0) {
      setYear(year - 1);
      setMonth(11);
    } else {
      setMonth(month - 1);
    }
  };
  const goRight = () => {
    if (month === 11) {
      setYear(year + 1);
      setMonth(0);
    } else {
      setMonth(month + 1);
    }
  };
  return (
    <Box
      display={'flex'}
      style={{
        flexDirection: isRTL ? 'row' : 'row-reverse',
        borderRadius: 7,
        backgroundColor: '#eee',
        minWidth: 230,
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <IconButton onClick={goRight} title="next month">
        <MyIcon size={20} icon="right"></MyIcon>
      </IconButton>
      <Box
        style={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
          {mo} {year}
        </Typography>
      </Box>
      <IconButton onClick={goLeft} title="previous month">
        <MyIcon size={20} icon="left"></MyIcon>
      </IconButton>
    </Box>
  );
}

export default MonthNavigator;
